<template>
  <div class="py-3 border-bottom border-light text-mcf-color">
    <div class="pr-2 pl-3 d-flex w-100 position-relative">
      <span v-if="hasRedDot" class="bg-danger rounded-circle position-absolute" style="width: 0.5rem; height: 0.5rem; left: 0.5rem; top: 0.5rem;"></span>
      <figure class="mx-2">
        <div class="image-panel image-panel-2">
          <img :src="thumbnail" alt="" class="mw-100">
        </div>
      </figure>
      <div class="mx-2 flex-grow-1">
        <div class="d-flex align-items-start">
          <h6 class="mb-1 text-truncate-1">
            {{ notification.title }}
          </h6>
        </div>
        <div class="font-size-md mb-1 text-break-all" :class="[isFolded ? 'text-truncate-2' : '']" v-html="notification.content"></div>
        <div class="mx-n1 my-1" v-if="hasAttachment">
          <b-button class="mx-1 d-inline-flex align-items-center text-secondary" size="sm" pill variant="outline-light" @click="openAttachment">
            <img :src="attachmentIcon" alt="" style="height:1rem;">
            <span class="ml-1 text-truncate-1" style="max-width: 12em;">{{ notification.attachmentName }}</span>
          </b-button>
        </div>
        <div class="font-size-sm text-gray500">{{ notifyTime }}</div>
      </div>
      <a href="javascript: void(0)" @click="isFolded = !isFolded; hasRedDot = false;">
        <span class="material-icons text-gray500">
          {{ isFolded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import dateTimeFormatter from '@/utils/dateTimeFormatter';
import iconPhoto from '@/assets/images/icon-photo.svg';
import iconPdf from '@/assets/images/icon-pdf.svg';

// 附件類型對照表
const attachmentTypeLookUp = {
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  pdf: 'pdf',
  default: 'pdf',
};

// 附件圖示對照表
const attachmentIconLookUp = {
  image: iconPhoto,
  pdf: iconPdf,
  default: iconPdf,
};

export default {
  props: {
    // 通知資料
    notification: {
      type: Object,
      required: true,
    },
    // 預設縮圖
    defaultThumbnail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // 是否收合
      isFolded: true,
      // 是否有紅點
      hasRedDot: false,
    };
  },
  computed: {
    // 是否已讀
    hasRead() {
      return !!this.notification.readTime;
    },
    // 是否有附件
    hasAttachment() {
      return !!this.notification.attachmentName;
    },
    // 附件類型
    attachmentType() {
      const vm = this;
      if (!vm.hasAttachment) return null;
      const fileExtension = vm.notification.attachmentName.split('.').pop();
      return attachmentTypeLookUp[fileExtension] || attachmentTypeLookUp.default;
    },
    // 附件圖示
    attachmentIcon() {
      const vm = this;
      if (!vm.hasAttachment) return null;
      return attachmentIconLookUp[vm.attachmentType] || attachmentIconLookUp.default;
    },
    // 通知縮圖
    thumbnail() {
      const vm = this;
      // 若無附件，顯示預設縮圖
      if (!vm.hasAttachment) return vm.defaultThumbnail;
      // 若附件為圖片，將附件作為縮圖，否則顯示預設縮圖
      if (vm.attachmentType === 'image') return vm.notification.attachmentUrl;
      return vm.defaultThumbnail;
    },
    // 通知時間
    notifyTime() {
      return dateTimeFormatter.formatTaiwanDateTime(new Date(this.notification.createTime));
    },
  },
  created() {
    this.hasRedDot = !this.hasRead;
  },
  methods: {
    // 開啟附件
    openAttachment() {
      this.hasRedDot = false;
      window.open(this.notification.attachmentUrl);
    },
  },
};
</script>
